import React from 'react';
import { withRouter } from 'react-router-dom';
import { Layout, Menu, Row, Col, Card } from 'antd';
import img from '../../../assets/img/Illustratiion@3x.png';
import Footer from '../../Layout/Footer';
const {
  Header, Content,
} = Layout;
let add = false;
class LaunchPad extends React.Component {

  render() {
    const header = (<Header style={{ backgroundColor: '#f9f9fd', height: '80px', boxShadow: 'rgba(78, 86, 148, 0.35) 0px 0px 3px 3px' }}><div className="logo" style={{ marginTop: '28px' }} />
      <Menu
        theme="light"
        mode="horizontal"
        defaultSelectedKeys={['2']}
        style={{ lineHeight: '64px', height: '80px', backgroundColor: '#f9f9fd' }}
      >
        {/* <Menu.Item key=""> <span>Home </span></Menu.Item>
        <Menu.Item key="/about"><span>About </span></Menu.Item>
        <Menu.Item key="/help"><span>Help </span></Menu.Item> */}
      </Menu>
    </Header>);

    return (
      <Layout style={{ backgroundColor: 'white' }}>
        {header}
        <Content style={{ margin: '50px auto', backgroundColor: 'white' }}>
          <div className="mi_main_inv" style={{ borderRadius: '6px', boxShadow: '0px 0px 0px 2px #d9d9d9' }} >
            <div className="mi_box">
              <Row span={24}>
                <Col span={15}>
                  <h4 className="mi_box_h4"><strong>Welcome</strong></h4>
                  {/* <p className='mi_title2' style={{ color: 'white' }}>
                      Complete the following form in order to proceed registration as a Agent with us                                </p> */}
                </Col>
                <Col span={9}>
                  <img alt="example" style={{ height: '150px', marginTop: '-60px' }} src={img} />
                </Col>
              </Row>
            </div>
            <Row>
              <Col span={12} style={{ padding: '5px' }}>
                <Card onClick={() => window.location.href = "/register/broker"}>
                <a href='/register/broker' style={{fontSize:'22px'}}>
                    Broker
                  </a>
                </Card>
              </Col>
              <Col span={12} style={{ padding: '5px' }}>

                <Card onClick={() => window.location.href = "/register/agency"}>
                  <a href='/register/agency' style={{fontSize:'22px'}}>
                    Agency
                  </a>
                </Card>
              </Col>

            </Row>
          </div>
        </Content>
        <Footer className="mi_footer>"></Footer>

      </Layout>
    );

  }
}
let ex = withRouter(LaunchPad);
if (!add)
  ex = LaunchPad;
export default ex;